import enUs from './locale/en-us.js';
import { reactive } from 'vue';
import { defaultsDeep } from 'lodash-es';
// import { ZIndex } from '../../utils/zindex/zindex.js';
import { FilterMatchMode } from '../core/api/index.js';
/**
 *  What goes here? Common GLOBAL design options that need to be
 *  dynamic at run-time. For example, locale may be changed by
 *  selecting a button in the UI. So, these values load into the
 *  global space. Otherwise we just provide an export elsewhere
 *  in the design system.
 *
 *  This is a bit of future proofing, to provide an artifact of
 *  the design process more than anytying, so don't spend too much
 *  effort maintaining it.
 *
 *  Eventually, one day this may all roll into a single ui-comopnent
 *  plugin in. But for now, keeping the comopnent loading and the
 *  configuration separate.
 */

export const defaultOptions = {
  /**
   *  Provides a set of standard options so they don't ahve to be added every
   *  time and we can use them consistently.
   *  @todo consider moving thse to their own location/import as I don't
   *        see these ever being updated on a per/app basis. Do they really
   *        need to be configurable?
   */
  filterMatchModeOptions: {
      text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
      numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
      date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER]
  },
  locale: enUs,
  zIndex: {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tootip: 1100,
  },
};


export const UiComponentsConfig = {
  install (app, options) {
    const mergedOptions = defaultsDeep(defaultOptions, options);

    const uiConfig = reactive(mergedOptions);


    app.provide('$ui', uiConfig);

    Object.defineProperties(app.config.globalProperties, {
      $ui: { get: () => uiConfig.value },
    });
    // app.config.globalProperties.$ui = () => uiConfig.value;

    return uiConfig;
  }
};
